  import { isEqualTrackRef, isTrackReference, isWeb, log } from '@livekit/components-core';
  import { RoomEvent, Track } from 'livekit-client';
  import { VideoTrack } from '@livekit/components-react';
  import { AiOutlineFullscreen, AiOutlineFullscreenExit } from "react-icons/ai";
  import * as React from 'react';

  import {
    ConnectionStateToast,
    LayoutContextProvider,
    RoomAudioRenderer,
    useCreateLayoutContext,
    usePinnedTracks,
    useTracks,
  } from '@livekit/components-react';

  import './CustomStudentConference.css'
import FullscreenButton from './buttons/FulscreenButon';


  export default function VideoConferenceStudent({
    chatMessageFormatter,
    chatMessageDecoder,
    chatMessageEncoder,
    SettingsComponent,
    ...props
  }) {
    const [, setWidgetState] = React.useState({
      showChat: false,
      unreadMessages: 0,
      showSettings: false,
    });
    const lastAutoFocusedScreenShareTrack = React.useRef(null);

  
    const tracks = useTracks(
      [ 
        // {source: Track.Source.Microphone, withPlaceholder: false},
        { source: Track.Source.Camera, withPlaceholder: false },
        { source: Track.Source.ScreenShare, withPlaceholder: false },
      ],
      { updateOnlyOn: [RoomEvent.ActiveSpeakersChanged], onlySubscribed: false },
    );
  
    const widgetUpdate = (state) => {
      setWidgetState(state);
    };
  
    const layoutContext = useCreateLayoutContext();
  
    const screenShareTracks = tracks
      .filter(isTrackReference)
      .filter((track) => track.publication.source === Track.Source.ScreenShare);
  
    const focusTrack = usePinnedTracks(layoutContext)?.[0];

    React.useEffect(() => {
      if (
        screenShareTracks.some((track) => track.publication.isSubscribed) &&
        lastAutoFocusedScreenShareTrack.current === null
      ) {
        log.debug('Auto set screen share focus:', { newScreenShareTrack: screenShareTracks[0] });
        layoutContext.pin.dispatch?.({ msg: 'set_pin', trackReference: screenShareTracks[0] });
        lastAutoFocusedScreenShareTrack.current = screenShareTracks[0];
      } else if (
        lastAutoFocusedScreenShareTrack.current &&
        !screenShareTracks.some(
          (track) =>
            track.publication.trackSid ===
            lastAutoFocusedScreenShareTrack.current?.publication?.trackSid,
        )
      ) {
        log.debug('Auto clearing screen share focus.');
        layoutContext.pin.dispatch?.({ msg: 'clear_pin' });
        lastAutoFocusedScreenShareTrack.current = null;
      }
      if (focusTrack && !isTrackReference(focusTrack)) {
        const updatedFocusTrack = tracks.find(
          (tr) =>
            tr.participant.identity === focusTrack.participant.identity &&
            tr.source === focusTrack.source,
        );
        if (updatedFocusTrack !== focusTrack && isTrackReference(updatedFocusTrack)) {
          layoutContext.pin.dispatch?.({ msg: 'set_pin', trackReference: updatedFocusTrack });
        }
      }
    }, [
      screenShareTracks
        .map((ref) => `${ref.publication.trackSid}_${ref.publication.isSubscribed}`)
        .join(),
      focusTrack?.publication?.trackSid,
      tracks,
    ]);

    const videoRef = React.useRef()
    const [isFullScreen, setIsFullScreen] = React.useState(false)

    const requestFullScreen = (element) => {
      return element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
    }

    const cancellFullScreen = () => document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;

    const fullScreenToggle = () => {
      if (isFullScreen) {
        cancellFullScreen().call(document)
      } else {
        requestFullScreen(videoRef.current).call(videoRef.current)
      }
      setIsFullScreen(!isFullScreen)
    }

    return (
      <>
      <div className="lk-video-conference bg-black md:rounded-2xl relative overflow-hidden student-stream" {...props}>
        {isWeb() && (
          <LayoutContextProvider
            value={layoutContext}
            onWidgetChange={widgetUpdate}
          >
            <div className="lk-video-conference-inner">
            {tracks && tracks.length ?
              <div className={`flex relative items-center lk-video-conference-inner ${isFullScreen ? 'full-screen' : ''}`} ref={videoRef}>
                { 
                  tracks.map(track => <div className={`${track.source} tracks-${tracks.length}`}>
                    <VideoTrack key={track.publication.trackSid} trackRef={track} />
                  </div> )
                }
                <div className='absolute right-4 bottom-4 z-10'>
                  <FullscreenButton onClick={fullScreenToggle}>{isFullScreen ? <AiOutlineFullscreenExit /> : <AiOutlineFullscreen />}</FullscreenButton>
                </div>
              </div> :
              <div className='min-h-[40vh] md:min-h-[536px]'></div>
            }
            </div>
          </LayoutContextProvider>
        )}
        <RoomAudioRenderer />
        <ConnectionStateToast />
      </div>
      </>
    );
  }
  